"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var nation = {
  id: "awesomeNation",
  i18nName: {
    en: "Awesome Nation"
  }
};
var _default = nation;
exports.default = _default;